import {ChangeDetectionStrategy, Component, inject, input, signal} from "@angular/core"
import {MatSelectModule} from "@angular/material/select"
import {InterfaceDescriptor, isConfigInput, isMaterialInput, isBooleanInput, isNumberInput, isStringInput} from "@cm/template-nodes"
import {SelectMaterialButton} from "@common/components/viewers/configurator/config-menu/select-material/select-material.component"
import {ConfigMenuService} from "@common/components/viewers/configurator/config-menu/services/config-menu.service"
import {StringInputComponent} from "@app/common/components/inputs/string-input/string-input.component"
import {InputContainerComponent} from "@app/common/components/inputs/input-container/input-container.component"
import {NumericInputComponent} from "@app/common/components/inputs/numeric-input/numeric-input.component"
import {ToggleComponent} from "@app/common/components/buttons/toggle/toggle.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-default-menu",
    templateUrl: "./default-menu.component.html",
    styleUrls: ["./default-menu.component.scss"],
    imports: [MatSelectModule, SelectMaterialButton, StringInputComponent, InputContainerComponent, NumericInputComponent, ToggleComponent],
})
export class DefaultMenuComponent {
    readonly $interfaceDescriptors = input.required<InterfaceDescriptor<unknown, object>[]>({alias: "interfaceDescriptors"})

    readonly $isConfigInput = signal(isConfigInput)
    readonly $isMaterialInput = signal(isMaterialInput)
    readonly $isBooleanInput = signal(isBooleanInput)
    readonly $isNumberInput = signal(isNumberInput)
    readonly $isStringInput = signal(isStringInput)

    readonly configMenuService = inject(ConfigMenuService)
}
